import { useTranslation } from 'react-i18next';
import PageHeader from 'shared/components/page-header/page-header';

import CareConnectSettingsProvider from 'features/care-connect-settings/providers/care-connect-settings-provider';
import CareConnectOrganisationUnitTree from 'features/care-connect-settings/views/components/care-connect-organisation-unit-tree';
import CareConnectSettingsDetails from 'features/care-connect-settings/views/components/care-connect-settings-details';
import SettingTabs from 'features/settings/settings-tabs';
import styles from './care-connect-settings.module.scss';

const CareConnectSettings = (): React.JSX.Element => {
  const { t } = useTranslation('careConnectSettings');

  return (
    <>
      <PageHeader title={t('pageHeaderTitle')} navigationComponent={<SettingTabs />} />
      <CareConnectSettingsProvider>
        <div className={styles.container}>
          <div className={styles.leftContent}>
            <CareConnectOrganisationUnitTree />
          </div>
          <CareConnectSettingsDetails />
        </div>
      </CareConnectSettingsProvider>
    </>
  );
};

export default CareConnectSettings;
